"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/changeHistoryController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var ChangeHistoryController = function () {
        function ChangeHistoryController() {
            _classCallCheck(this, ChangeHistoryController);
        }

        _createClass(ChangeHistoryController, [{
            key: "getPolicyRelatedChanges",
            value: function getPolicyRelatedChanges(request) {
                return abortingRequest.send('/api/ChangeHistory/GetPolicyRelatedChanges', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "getVehicleHistory",
            value: function getVehicleHistory(request) {
                return abortingRequest.send('/api/ChangeHistory/GetVehicleHistory', ajaxSettingsProvider.httpPost(request));
            }
        }, {
            key: "getAddressHistory",
            value: function getAddressHistory(request) {
                return abortingRequest.send('/api/ChangeHistory/GetAddressHistory', ajaxSettingsProvider.httpPost(request));
            }
        }]);

        return ChangeHistoryController;
    }();

    return new ChangeHistoryController();
});
//# sourceMappingURL=changeHistoryController.js.map;
